import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";

import qs from "query-string";
import ProjectTable from "pages/unionwear/components/ProjectTable";
import UnionwearLayout from "pages/unionwear/layout";

const UnionwearPage = () => {
  return (
    <SuiBox>
      <UnionwearLayout>
        <ProjectTable />
      </UnionwearLayout>
    </SuiBox>
  );
};

export default UnionwearPage;
